/* global app */
/* global event */
/* global members, group, mdc, groupPermissions, existingEvents */
app.controller('groupCtrl', ['$rootScope', '$scope', '$http', '$compile', 'NetworkService', 'AtlasDialog', 'AtlasNotification', '$timeout', function($rootScope, $scope, $http, $compile, NetworkService, AtlasDialog, AtlasNotification, $timeout) {

    $scope.members = members;
    $scope.group = group;
    $scope.groupPermissions = groupPermissions || [];
    $scope.searchUser = {};
    $scope.searchUsers = [];
    $scope.showPhantomEntry = false;
    
    $scope.searchState = 0;
    $scope.menu = new mdc.menu.MDCMenu(document.querySelector(".mdc-menu"));
    $scope.menu.setAnchorMargin({top: 20});
    
    //This is for initing the component
    $scope.menu.open = false;
    $scope.menu.open = true;
    $scope.menu.open = false;
    $scope.existingEvents = existingEvents;
    $scope.searchedEvent = {};
    
    document.addEventListener("click", function(e){
        $scope.menu.open = false;
    })
    
    $scope.phantomEntryChanged = function(){
        $scope.dataTables.groupTable.showPhantomCheck()
    }
    
    $rootScope.$on("ACDataTable:groupTable:finished", function(){
        $timeout(function(){
        NetworkService.callOperation("reload/group/"+$scope.group.groupId, {}, function(response){
            
                $scope.groupPermissions = response.get("groupPermissions")
            
        })},100)
                        
         $scope.dataTables.groupTable.removeEntry = function(selected){
            selected.forEach(function(ind){
                var groupPermission = $scope.groupPermissions[ind];
                var data = {
                    groupId: $scope.group.groupId,
                    permissionLevel: groupPermission.Berechtigungslevel,
                    eventId: groupPermission.Veranstaltungsnummer
                };
                if(groupPermission.positionName == null){
                    NetworkService.callOperation("removegrouppermissifromtoevent", data, function(response){
                        if(response.isSuccessfull()){
                            AtlasNotification.info("Gruppenberechtigung wurde erfolgreich entfernt.");
                        }
                        
                        NetworkService.callOperation("reload/group/"+$scope.group.groupId, {}, function(response){
                            $scope.groupPermissions = response.get("groupPermissions");
                        })
                    })
                }else{
                    AtlasNotification.info("Hier können momentan nur Veranstaltungsberechtigungen gelöscht werden.");
                }
                
            })
         }
         
        $scope.dataTables.groupTable.saveEntry = function(phantomData){
            var data = {
                eventId: phantomData.Veranstaltungsname.Veranstaltungsnummer,
                permissionLevel: phantomData.Stufe,
                groupId: $scope.group.groupId
            }
            NetworkService.callOperation("addgrouppermissiontoevent", data, function(response){
                if(response.isSuccessfull()){
                    AtlasNotification.info("Event wurde erfolgreich hinzugefügt.");
                }
                $scope.dataTables.groupTable.closePhantomEntry();
                
                NetworkService.callOperation("reload/group/"+$scope.group.groupId, {}, function(response){
                    $scope.groupPermissions = response.get("groupPermissions");
                })
            })
        }
    })
    
    $scope.addEvent = function(event){
        $scope.searchedEvent = event;
        $scope.searchfield = event.Veranstaltungsname;    
    }
    
    $scope.openAddRow = function(){
        $scope.searchState = 1;
    }
    
    $scope.setSearchUser = function(){
        $scope.searchUser = $scope.searches.userSearch.result;
        $scope.searchState = 2;
    }
    
    $scope.addUserToGroup = function(user){
        var data = {userId: user.id, groupId: $scope.group.groupId}
        NetworkService.callOperation("addusertogroup", data, function(response){
            if(response.isSuccessfull()){
                AtlasNotification.info("User wurde erfolgreich zur Gruppe hinzugefügt.");
                location.reload()
                $scope.searchState = 0;
                $scope.members.push(user)
                $scope.searchUser = {};
            }
        })
    }
    
    $scope.removeUserFromGroup = function(user){
        var data = {
            userId: user.id,
            groupId: $scope.group.groupId
        };
        
        
        NetworkService.callOperation("removeUserFromGroup", data, function(response) {
            AtlasNotification.info("User wurde erfolgreich aus der Gruppe entfernt.");
            location.reload()
        })
    }
    
    $scope.searchForUser = function(){
        //console.log($scope.searches.userSearch.searchField)
        var spl = $scope.searches.userSearch.searchField.split(" ");
        if(spl.length == 1){
            var user = {
            email: $scope.searches.userSearch.searchField,
            firstName: $scope.searches.userSearch.searchField,
            secondName: $scope.searches.userSearch.searchField
            };
        }else if(spl.length == 2){
            var user = {
            email: $scope.searches.userSearch.searchField,
            firstName: spl[0],
            secondName: spl[1]
            };
        }
        
        
        NetworkService.callOperation("searchforuser", user, function(response){
            var users = response.get("users");
             $scope.searchUsers = users;
             if(!document.querySelector(".mdc-menu").classList.contains("mdc-menu-surface--open")){
                 //document.querySelector(".mdc-menu").classList.add("mdc-menu-surface--open")
             }
        });
    }
}])
